module.exports = __webpack_public_path__ + "static/media/thumbnail.65ef4837.jpg";